import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { WhatYouWillLearn } from './components/WhatYouWillLearn';
import { SupportMaterial } from './components/SupportMaterial';
import { ClassesContent } from './components/ClassesContent';
import { Bonuses } from './components/Bonuses';
import { ProfessionalOpportunity } from './components/ProfessionalOpportunity';
import { Certificate } from './components/Certificate';
import { SocialProof } from './components/SocialProof';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { ExitPopup } from './components/ExitPopup';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-[#07152D] selection:bg-[#FFC900] selection:text-[#07152D]" data-id="element-0" data-mp="23ti8k5ohswkq">
      {/* Top sticky banner similar to reference */}
      <div className="w-full bg-[#E90032] text-white text-center py-3 px-4 text-[12px] md:text-[14px] font-[800] uppercase flex items-center justify-center gap-2 min-h-[52px]" style={{
      fontSize: "10px",
      paddingBottom: "8px"
    }} data-id="element-1" data-mp="3mjzrt22ccy08">
        <span className="text-[#FFC900] text-lg" data-id="element-2" data-mp="2zl3dbpgpde7f">⚡</span> OFERTA ESPECIAL DISPONIBLE POR TIEMPO LIMITADO
      </div>
      
      <main data-id="element-3" data-mp="33lwyib2rgewm">
        <Hero data-id="element-4" data-mp="33nq55qddiz4m" />
        <WhatYouWillLearn data-id="element-5" data-mp="33n6y54p9hv5d" />
        <SupportMaterial data-id="element-6" data-mp="33oi2p6qj76xj" />
        <ClassesContent data-id="element-7" data-mp="38l8idsyfc0if" />
        <Bonuses data-id="element-8" data-mp="38kqfwel64q22" />
        <ProfessionalOpportunity data-id="element-9" data-mp="38k6wsujs7vmg" />
        <Certificate data-id="element-10" data-mp="3dkuws5pznmst" />
        <SocialProof data-id="element-11" data-mp="3dle4yupu6wtn" />
        <Offer data-id="element-12" data-mp="3dlnu6g324zya" />
        <Guarantee data-id="element-13" data-mp="3dm5ylzzvikha" />
        <FAQ data-id="element-14" data-mp="3dii4aymltu1i" />
        <FinalCTA data-id="element-15" data-mp="nvj179a902mk" />
      </main>
      
      <Footer data-id="element-16" data-mp="nuhj4kutefvc" />
      <ExitPopup data-id="element-17" data-mp="nv0xxsp64o55" />
      <SalesPopup data-id="element-18" data-mp="nxn4pq48izmb" />
    </div>;
}